import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ShopDetailsContainer } from '../containres/ShopDetailsContainer';
import getEnvConfig from '../../../../../utils/config/env';
import { ShopDetailsEditContainer } from '../containres/ShopDetailsEditContainer';

export const ShopDetailsPage = () => {
    const navigate = useNavigate();

    return (
        <>
            {/*  <div
                onClick={() =>
                    navigate(
                        `${getEnvConfig().PUBLIC_PATH}/admin/shop-detail/1`
                    )
                }
            >
                111
            </div>*/}

            <ShopDetailsEditContainer />

            <ShopDetailsContainer />
        </>
    );
};
